var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 19.1667C12.5837 16.3333 11.417 13.75 7.16699 13.3333C11.417 12.9167 12.5837 10.3333 13.0003 7.5C13.417 10.3333 14.5837 12.9167 18.8337 13.3333C14.5003 13.75 13.3337 16.3333 13.0003 19.1667Z",
    stroke: "url(#paint0_linear_2392_40709)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91634 10C5.58301 7.75004 4.66634 5.75004 1.33301 5.41671C4.66634 5.08337 5.58301 3.08337 5.91634 0.833374C6.24967 3.08337 7.16634 5.08337 10.4997 5.41671C7.08301 5.75004 6.16634 7.75004 5.91634 10Z",
    stroke: "url(#paint1_linear_2392_40709)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 4.99996C15.7503 4.16663 15.417 3.41663 14.167 3.33329C15.417 3.24996 15.7503 2.49996 15.8337 1.66663C15.917 2.49996 16.2503 3.24996 17.5003 3.33329C16.2503 3.41663 15.917 4.16663 15.8337 4.99996Z",
    stroke: "url(#paint2_linear_2392_40709)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2392_40709",
    x1: 18.8337,
    y1: 13.3333,
    x2: 7.16699,
    y2: 13.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D439FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE6300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2392_40709",
    x1: 10.4997,
    y1: 5.41671,
    x2: 1.33301,
    y2: 5.41671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D439FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE6300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2392_40709",
    x1: 17.5003,
    y1: 3.33329,
    x2: 14.167,
    y2: 3.33329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D439FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE6300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/AI-icon.720bf411722934aecab55435aacff3d7.svg";
export { ForwardRef as ReactComponent };